export const User = data => ({
  id: data.id,
  name: data.name,
  avatarUrl: data.avatarUrl,
});

export const responseDataToUser = responseData => {
  return new User({
    id: responseData.id,
    name: responseData.attributes.displayName,
    avatarUrl: responseData.attributes.avatarUrl,
  });
};

export const responseToUser = response => {
  return responseDataToUser(response.data.data);
};

export const responseToUserList = response => {
  let data = response.data.data;
  if (!Array.isArray(data)) {
    data = [data];
  }
  return data.map(responseDataToUser);
};
